import { useMemo } from "react";
import { getCandidateStatusKey } from "../../../../../utilities/candidate";

export const isIncomingTransition = (t, subStatus) =>
  t.toStatusId === subStatus?.statusId && t.toSubStatusId === subStatus?.id;

export const isOutgoingTransition = (t, subStatus) =>
  t.fromStatusId === subStatus?.statusId && t.fromSubStatusId === subStatus?.id;

export const useStatusTransitions = (
  transitions,
  subStatus,
  active = false,
) => {
  return useMemo(() => {
    const incoming = transitions.filter((t) => {
      const isIncoming = isIncomingTransition(t, subStatus);
      return isIncoming && (!active || t.isActive === true);
    });

    const outgoing = transitions.filter((t) => {
      const isOutgoing = isOutgoingTransition(t, subStatus);
      return isOutgoing && (!active || t.isActive === true);
    });

    const incomingSourceIds = new Set(
      incoming.map((t) =>
        getCandidateStatusKey(t.fromStatusId, t.fromSubStatusId),
      ),
    );

    const outgoingTargetIds = new Set(
      outgoing.map((t) => getCandidateStatusKey(t.toStatusId, t.toSubStatusId)),
    );

    return {
      incomingTransitions: incoming,
      outgoingTransitions: outgoing,
      incomingSourceIds,
      outgoingTargetIds,
    };
  }, [transitions, subStatus, active]);
};
